import React from 'react';
import { FormikProps, Field } from 'formik';
import { LabelFieldHorizontal, Checkbox, CheckboxGroup } from '@epicode/react-inspinia';
import { QuestionnaireMultipleChoice } from '../../../../api/jobOffers/jobOffers.dto';
import _ from 'lodash';
import styles from './QuestionnaireMultipleChoice.module.scss';
import classNames from 'classnames';

export function renderQuestionnaireMultipleChoice<T extends Record<string, any>>(formikProps: FormikProps<T>) {
    return (element: QuestionnaireMultipleChoice, label?: string) => {
        return (
            <LabelFieldHorizontal for={element.id} label={label} key={element.id}>
                <div className={classNames('d-flex flex-column', styles.container)}>
                    <CheckboxGroup
                        id={element.id}
                        name={element.id}
                        value={formikProps.values[element.id] || []}
                        handleChange={formikProps.setFieldValue}
                        handleBlur={formikProps.setFieldTouched}>
                        {_.map(element.options, (optionText, optionValue) => (
                            <Field
                                component={Checkbox}
                                name={element.id}
                                value={optionValue}
                                label={optionText}
                                key={optionValue}
                            />
                        ))}
                    </CheckboxGroup>
                </div>
            </LabelFieldHorizontal>
        );
    };
}
